import React from "react"
import DfbHeadline from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline"
import DfbRte from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte"
import OpenCloseIcon from "@dfb/gatsby-dfb-theme/src/components/elements/open_close_icon"
import CImage from "@dfb/gatsby-dfb-theme/src/components/elements/c_image"
import Section from "@dfb/gatsby-dfb-theme/src/components/blocks/section"

const MAccordion = ({ data }) => {
  const { kicker, headline, accordion_element, uid } = data
  return (
    <Section
      baseClass="m-Accordion"
      defaultPaddingTop="small"
      data={data}
    >
      <div className="m-Accordion-wrapper">
        <div className="m-Accordion-container">
          {(headline || kicker) && (
            <>
              {kicker && (
                <DfbHeadline
                  headline={kicker}
                  headline_level="h3"
                  add_class="m-Accordion-headline"
                />
              )}
              {headline && (
                <DfbHeadline
                  headline={headline}
                  headline_level="h2"
                  add_class="m-Accordion-headline"
                />
              )}
            </>
          )}
          <div className="m-Accordion-content">
            <ol className="c-Accordion">
              {accordion_element &&
                accordion_element.map(
                  (accordion_element, accordion_element_index) => (
                    <li
                      className="c-Accordion-item"
                      data-item={accordion_element_index}
                      key={`${uid}-${accordion_element_index}`}
                    >
                      <button className="c-Accordion-button" type="button">
                        {accordion_element.accordion_title && (
                          <span className="c-Accordion-buttonTitle">
                            {accordion_element.accordion_title}
                          </span>
                        )}
                        <span className="c-Accordion-icon">
                          <OpenCloseIcon />
                        </span>
                      </button>
                      <div className="c-Accordion-content">
                        {(accordion_element.accordion_image && accordion_element.accordion_image.src) && (
                          <CImage data={accordion_element.accordion_image} className="c-Accordion-image" captionClassName="m-Image-figcaption" />
                        )}
                        {accordion_element.accordion_text && (
                          <div className="c-Accordion-rte">
                            <DfbRte text={accordion_element.accordion_text} />
                          </div>
                        )}
                      </div>
                    </li>
                  )
                )}
            </ol>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MAccordion
